import { Chip } from '@mui/material'
import { useMedia } from '@/fractals/hooks'

export const FullContentChip = ({
  label,
  color
}: {
  label: string
  color: string | null
}) => {
  const { isTablet, isMobile } = useMedia()
  const isSmallScreen = isTablet || isMobile

  return (
    <Chip
      label={label}
      sx={{
        backgroundColor: color,
        color: '#fff',
        fontSize: isSmallScreen ? '16px' : '20px',
        lineHeight: '120%',
        fontFamily: 'inherit',
        borderRadius: '32px',
        padding: isSmallScreen ? '8px 16px' : '8px 4px',
        '& .MuiChip-label': {
          padding: isSmallScreen ? 0 : '0px 12px'
        }
      }}
    />
  )
}
